/**
 * SECTION 3B JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
import aon_craft_utils from './aon_craft_utils.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Section 3B, data
         * UI interaction functions etc
         */
        console.log( 'Section 3B - init' );
                     
        this.aon_section_3b_data = [];
        
        // Get any existing saved data...
        if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
            this.loadData( 'load_live' );
            
        } else { // If not Business Plan page then we are in 3B...
            if ( $( '#section_3b_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
                this.loadData( 'load_live' );
                
            } else { // If no saved data then we start with a default data structure...
                this.loadData( 'start' ); 
            }
            //this.loadData( 'load_demo' );
        }
        
        this.renderWordEntries();
        this.renderUSPText();
        
        
        $( 'body' ).on( 'keyup', '.usp_page textarea', function( event ) {
            var id = $( this ).attr( 'id' );
            callCheckUSPTextFunction( id );
            
            if ( $( this ).attr( 'id' ) == 'idea' ) {
                $( '#idea_summary' ).val( $( aon_craft_utils.removeHTMLTags( this ).val() ) );
            } else if ( $( this ).attr( 'id' ) == 'production' ) {
                $( '#production_summary' ).val( aon_craft_utils.removeHTMLTags( $( this ).val() ) );
            } else if ( $( this ).attr( 'id' ) == 'distribution' ) {
                $( '#distribution_summary' ).val( aon_craft_utils.removeHTMLTags( $( this ).val() ) );
            } else if ( $( this ).attr( 'id' ) == 'customer' ) {
                $( '#customer_summary' ).val( aon_craft_utils.removeHTMLTags( $( this ).val() ) );
            } else if ( $( this ).attr( 'id' ) == 'usp_story' ) {
                $( '#usp_story_summary' ).val( aon_craft_utils.removeHTMLTags( $( this ).val() ) );
            } else if ( $( this ).attr( 'id' ) == 'idea_summary' ) {
                $( '#idea' ).val( aon_craft_utils.removeHTMLTags( $( this ).val() ) );
            } else if ( $( this ).attr( 'id' ) == 'production_summary' ) {
                $( '#production' ).val( aon_craft_utils.removeHTMLTags( $( this ).val() ) );
            } else if ( $( this ).attr( 'id' ) == 'distribution_summary' ) {
                $( '#distribution' ).val( aon_craft_utils.removeHTMLTags( $( this ).val() ) );
            } else if ( $( this ).attr( 'id' ) == 'customer_summary' ) {
                $( '#customer' ).val( aon_craft_utils.removeHTMLTags( $( this ).val() ) );
            } else if ( $( this ).attr( 'id' ) == 'usp_story_summary' ) {
                $( '#usp_story' ).val( aon_craft_utils.removeHTMLTags( $( this ).val() ) );
            }
            
            event.preventDefault();
        });
        
        var callCheckUSPTextFunction = ( id ) => {
            this.checkUSPTextareasNotEmpty( id );
        }
        
        
        $( 'body' ).on( 'click', '.usp_next', function( event ) {
            //var class = $( this ).attr( 'id' );
            if ( $( this ).hasClass( 'idea_next' ) ) {
                $( '.idea_text' ).text( aon_craft_utils.removeHTMLTags( $( '#idea' ).val() ) );
                saveUSPEntry( 'idea', aon_craft_utils.removeHTMLTags( $( '.key_block #idea' ).val() ) );
            } else if ( $( this ).hasClass( 'production_next' ) ) {
                $( '.production_text' ).text( aon_craft_utils.removeHTMLTags( $( '#production' ).val() ) );
                saveUSPEntry( 'production', aon_craft_utils.removeHTMLTags( $( '.key_block #production' ).val() ) );
            } else if ( $( this ).hasClass( 'distribution_next' ) ) {
                $( '.distribution_text' ).text( aon_craft_utils.removeHTMLTags( $( '#distribution' ).val() ) );
                saveUSPEntry( 'distribution', aon_craft_utils.removeHTMLTags( $( '.key_block #distribution' ).val() ) );
            } else if ( $( this ).hasClass( 'customer_next' ) ) {
                $( '.customer_text' ).text( aon_craft_utils.removeHTMLTags( $( '#customer' ).val() ) );
                saveUSPEntry( 'customer', aon_craft_utils.removeHTMLTags( $( '.key_block #customer' ).val() ) );
            } else if ( $( this ).hasClass( 'usp_story_next' ) ) {
                saveUSPEntry( 'usp_story', aon_craft_utils.removeHTMLTags( $( '.key_block #usp_story' ).val() ) );
            }
            
            if ( $( this ).hasClass( 'idea_back' ) ) {
                saveUSPEntry( 'idea', aon_craft_utils.removeHTMLTags( $( '.key_block #idea' ).val() ) );
            } else if ( $( this ).hasClass( 'production_back' ) ) {
                saveUSPEntry( 'production', aon_craft_utils.removeHTMLTags( $( '.key_block #production' ).val() ) );
            } else if ( $( this ).hasClass( 'distribution_back' ) ) {
                saveUSPEntry( 'distribution', aon_craft_utils.removeHTMLTags( $( '.key_block #distribution' ).val() ) );
            } else if ( $( this ).hasClass( 'customer_back' ) ) {
                saveUSPEntry( 'customer', aon_craft_utils.removeHTMLTags( $( '.key_block #customer' ).val() ) );
            } else if ( $( this ).hasClass( 'usp_story_back' ) ) {
                saveUSPEntry( 'usp_story', aon_craft_utils.removeHTMLTags( $( '.key_block #usp_story' ).val() ) );
            }
            
            event.preventDefault();
        });
        
        $( '#add_new_word_modal' ).on( 'open.zf.reveal', function() {
            $( '#add_new_word_modal input' ).val( '' );
            $( '#add_new_word_modal input' ).focus();
            //console.log( 'add_new_word_modal open' );
        });

        $( '#add_new_word_modal' ).on( 'closed.zf.reveal', function() {
            $( '#add_new_word_modal input' ).val( '' );
            //add_triangles_circles_modal_target = '';
            //console.log( 'add_new_word_modal close' );
        });

        $( 'body' ).on( 'click', '.lozenges_selector .add', function( event ) {
            event.preventDefault();
        });
        
        // Add word to list via Save button in "Add Your Own" modal...
        $( '#save_add_new_word' ).on( 'click', function( event ) {
            var new_word = aon_craft_utils.removeHTMLTags( $( '#add_new_word_modal input' ).val() );
            if ( new_word !== '' ) {
                checkNewWordEntry( new_word );
            }
            event.preventDefault();
        });
        
        // Add word to list via Click on one of the existing word lozenge items...
        $( 'body' ).on( 'click', '.lozenge_item', function( event ) {
            var new_word = $( this ).text();
            if ( new_word !== '' ) {
                checkNewWordEntry( new_word );
            }
            event.preventDefault();
        });
        
        // Remove word from list via Click on one of the seleced word lozenge items...
        $( 'body' ).on( 'click', '.lozenge_item_selected', function( event ) {
            if ( !$( this).parents( '.lozenges_selected_words' ).hasClass( 'no_interaction') ) {
                //console.log( 'lozenge_item_selected' );
                var delete_word = $( this ).text();
                if ( delete_word !== '' ) {
                    deleteWordEntry( delete_word );
                }
            } else {
                //console.log( 'No interaction on lozenges' );
            }
            event.preventDefault();
        });
        
        var checkNewWordEntry = ( new_word ) => { // Function defined using arrow method to gain access to main 'this'
            // Check how many words exist before adding so we don't add more than 5...
            var updated_words = [];
            $.each( this.aon_section_3b_data, function( index ) {
                if ( this.words != '' ) {
                    var aon_words_lower_arr = this.words.toLowerCase().split( ',' ); // forced to lower case for comparison
                    var aon_words_arr = this.words.split( ',' );
                    //console.log ( 'aon_words_arr: ' + aon_words_arr );
                    if ( aon_words_lower_arr.length < 5 && aon_words_lower_arr.indexOf( new_word.toLowerCase() ) === -1 ) { // if words array is less than 5 and new word doesn't match an existing word...
                        aon_words_arr.push( new_word );
                        updated_words = aon_words_arr.join( ',' );
                        //console.log( 'updated_words: ' + updated_words );
                        //console.log( 'this: ' + this.words );
                        //this.words = updated_words;
                        saveNewWordEntry( updated_words );

                    } else if ( aon_words_lower_arr.length < 5 && aon_words_lower_arr.indexOf( new_word.toLowerCase() ) !== -1 ) { // if words array is less than 5 and new word matches an existing word...
                        console.log( 'The Word "' + new_word + '" was added already!' );
                    } else {
                        console.log( 'Max 5 Words added already!' );
                    }
                } else {
                    saveNewWordEntry( new_word );
                }
                //console.log( 'this: ' + this.words );
                
            });
  
        }
                
        var saveNewWordEntry = ( updated_words ) => { // Function defined using arrow method to gain access to main 'this'
            //console.log( 'saveNewWordEntry - start ' );
            //console.log( 'this.aon_section_3b_data[ 0 ][ \'words\' ]' + this.aon_section_3b_data[ 0 ][ 'words' ] );
            //console.log( 'Saving new word to array ' );
            this.aon_section_3b_data[ 0 ][ 'words' ] = updated_words;
            //console.log( 'this.aon_section_3b_data[ 0 ][ \'words\' ]' + this.aon_section_3b_data[ 0 ][ 'words' ] );
            this.renderWordEntries();
            $( '#add_new_word_modal' ).foundation( 'close' );
            
            console.table( this.aon_section_3b_data );
        }
        
        var deleteWordEntry = ( delete_word ) => { // Function defined using arrow method to gain access to main 'this'
            //console.log( this.aon_section_3b_data[ 0 ][ 'words' ] );
            var updated_words = [];
            var aon_words_arr = this.aon_section_3b_data[ 0 ][ 'words' ].split( ',' );
            $.each( aon_words_arr, function( index, value ) {
                if ( value == delete_word ) {
                    //console.log( 'Deleting: ' + delete_word );
                    var dw_index = aon_words_arr.indexOf( delete_word );
                    if ( dw_index !== -1 ) {
                        aon_words_arr.splice( dw_index, 1 );

                    }
                    updated_words = aon_words_arr.join( ',' );
                    //console.table( aon_words_arr );
                    // Delete 'delete_word' from array...
                }
            });
            this.aon_section_3b_data[ 0 ][ 'words' ] = updated_words;
            
            this.renderWordEntries();
            $( '#add_new_word_modal' ).foundation( 'close' );
            
            console.table( this.aon_section_3b_data );
        
        }
        
        var saveUSPEntry = ( targ, content ) => { // Function defined using arrow method to gain access to main 'this'
            //console.log( 'saveUSPEntry - start ' );
            //console.log( 'Saving new word to array ' );
            this.aon_section_3b_data[ 0 ][ targ ] = content;
            console.table( this.aon_section_3b_data ); 
        }
            
            
        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });


    },
    
    renderWordEntries() {
        /*
         * Load / render existing Words to list...
         */
        //console.log( 'renderWordEntries - start' );
        //console.table( this.aon_section_3b_data );  
        
        // Remove any existing entries so that we don't re-render...
        $( '.lozenges_selected_words ul li' ).remove();
   
        // Loop over data array...
        var entry_count = 1;
        $.each( this.aon_section_3b_data, function( index ) {
            // Begin entry...           
            var lozenge_item_count = 0;
            if ( this.words != '' ) {
                var aon_words_arr = this.words.split( ',' );
                
                $.each( aon_words_arr, function( index, value ) {
                    var aon_word_item = '<a href="#word_entry" class="button rounded lozenge_item_selected entry_' + entry_count + '" data-word-entry-id="' + index + '">' + value + '</a>';
                    $( '.lozenges_selected_words ul' ).append( '<li>' + aon_word_item + '</li>' );
                    lozenge_item_count = index + 1;
                });

                // Enable / disable Next button depending on whether 5 words have been added...
                if ( aon_words_arr.length < 5 ) {
                    $( '.five_words_add_next' ).addClass( 'disabled' );
                    $( '.lozenges_selector .add' ).show();
                } else {
                    $( '.five_words_add_next' ).removeClass( 'disabled' );
                    $( '.lozenges_selector .add' ).hide();
                }
            
            }
            $( '.lozenge_item_count' ).text( lozenge_item_count );
       
            entry_count++;
        });
        
        this.toggleWordState();
        
        //console.log( 'renderWordEntries - end' );

    },
    
    loadSavedWords() {
        if ( this.aon_section_3b_data[ 0 ][ 'words' ] !== '' ) {
            // Load words int0
        }
    },
    
    toggleWordState() {
        var aon_words_arr = this.aon_section_3b_data[ 0 ][ 'words' ].toLowerCase().split( ',' );
        //aon_words_arr.indexOf( new_word.toLowerCase() ) === -1 )
        $( '.lozenges_selector li a' ).each(function( index ) {
            if ( aon_words_arr.indexOf( $( this ).text().toLowerCase() ) !== -1 ) { // If words array item matches one of the words in the lozenge list then set as disabled...
                $( this ).addClass( 'disabled' );
            } else {
                $( this ).removeClass( 'disabled' );
            }
        });
    },
    
    checkUSPTextareasNotEmpty( id ) {
        var stripped_id = id.replace( '_summary', '' );
        if ( $( '#'+stripped_id ).val() != '' ) {
            $( '.' + stripped_id + '_next' ).removeClass( 'disabled' );
        } else {
            $( '.' + stripped_id + '_next' ).addClass( 'disabled' );
        }
    },
    
    renderUSPText() {
        /*
         * Load / render existing USP text to textareas...
         */
        //console.log( 'renderUSPText - start' );
        // Remove any existing text to avoid duplicate rendered text...
        $( '.usp_page textarea' ).val( '' );
   
        // Loop over data array...
        var entry_count = 1;
        $.each( this.aon_section_3b_data, function( index ) {
            // Begin entry...           
            $( '.key_block #idea' ).val( this.idea );
            $( '#idea_summary' ).val( this.idea );
            $( '.key_block #production' ).val( this.production );
            $( '#production_summary' ).val( this.production );
            $( '.key_block #distribution' ).val( this.distribution );
            $( '#distribution_summary' ).val( this.distribution );
            $( '.key_block #customer' ).val( this.customer );
            $( '#customer_summary' ).val( this.customer );
            $( '.key_block #usp_story' ).val( this.usp_story );
            $( '#usp_story_summary' ).val( this.usp_story );
        });
        this.checkUSPTextareasNotEmpty( 'idea' );
        this.checkUSPTextareasNotEmpty( 'idea_summary' );
        this.checkUSPTextareasNotEmpty( 'production' );
        this.checkUSPTextareasNotEmpty( 'production_summary' );
        this.checkUSPTextareasNotEmpty( 'distribution' );
        this.checkUSPTextareasNotEmpty( 'distribution_summary' );
        this.checkUSPTextareasNotEmpty( 'customer' );
        this.checkUSPTextareasNotEmpty( 'customer_summary' );
        this.checkUSPTextareasNotEmpty( 'usp_story' );
        this.checkUSPTextareasNotEmpty( 'usp_story_summary' );
        
        //console.log( 'renderUSPText - end' );

    },
    
    addDataEntry() {
        // Default variables for data structure...
        var words = '';
        var idea = '';
        var production = '';
        var distribution = '';
        var customer = '';
        var usp_story = '';
        
        // Push default data to data structure array...
        this.aon_section_3b_data.push( { 
            words,
            idea,
            production,
            distribution,
            customer,
            usp_story
            
        } );
        
        console.table( 'addDataEntry: ' + this.aon_section_3b_data );
    },
    
    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        
        // Load data from backend...
        if ( mode == 'load_live' ) {
            // Load from json array in page
            var aon_section_3b_data_json = $( '#section_3b_data_json' ).val();
            this.aon_section_3b_data = JSON.parse( aon_section_3b_data_json );
            
            
        } else if ( mode == 'load_demo' ) {
             var aon_section_3b_data_json = '[';
                aon_section_3b_data_json += '{"words":"Classic,Innovative,Playful","idea":"","production":"","distribution":"","customer":"","usp_story":""}';
                aon_section_3b_data_json += ']';

            this.aon_section_3b_data = JSON.parse( aon_section_3b_data_json );

        } else if ( mode == 'start' ) {

            this.addDataEntry();
            
        }
        console.table( this.aon_section_3b_data );
        //console.log( 'this.aon_section_3b_data[0][\'words\']: ' + this.aon_section_3b_data[0]['words'] );
  
    },
    
        saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        var jsonDataString = JSON.stringify( this.aon_section_3b_data );
        console.log( 'jsonDataString: ' + jsonDataString );
        
        console.log( '3B AJAX - START' );
        var meta = { 'section_3b_data_one' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '3B AJAX - END' );
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_section_3b_data );
    },
    
}